// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-data[data-v-3f68e3af]{padding:1rem}li[data-v-3f68e3af]{color:#333}", ""]);
// Exports
module.exports = exports;
